import axios from 'axios';
import NetworkApi from './networkApi';
import paths from './path';

export const getScopeListing = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const { data } = await NetworkApi.get(paths.listingUrlForScope, headers);

  return data;
};

export const getDeleteUser = async (id) => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.delete(paths.deleteUserUrl(id), headers);

  return data;
};

export const getResendInvite = async (id) => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.get(paths.resendInviteUrl(id), headers);

  return data;
};

export const getUserInvite = async (body) => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.post(paths.inviteUserUrl, body, headers).then((res) => {
    return res;
  });

  return data;
};

export const getPendingInvites = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.get(paths.pendingInvitesUrl, headers).then();

  return data;
};

export const getConfirmInvites = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const data = await NetworkApi.get(paths.confirmInvitesUrl, headers).then();

  return data;
};

export const getUpdateUser = async (data) => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };
  const { firstName, lastName, type, id, domains, job_title, workEmail } = data;

  const body = {
    first_name: firstName,
    last_name: lastName,
    type,
    job_title,
    work_email: workEmail,
    domains,
  };

  const response = await NetworkApi.put(paths.updateUserUrl(id), body, headers);

  return response;
};

export const getAllUsers = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const { data } = await fetch(`${paths.getAllUsersUrl}auth/admin/allEmployees`, { headers })
    .then((res) => res.json())
    .then((res) => {
      return res;
    });

  return data;
};

export const getUserProfile = async () => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };

  const { data } = await axios(`${URL}auth/users/get/profile`, {
    headers,
  }).then((res) => {
    return res;
  });

  return data;
};

export const getUpdateUserType = async (userData) => {
  const headers = {
    Authorization: `${localStorage.getItem('token')}`,
  };
  const { type, id } = userData;
  const body = { type };

  const { data } = await axios
    .put(`${URL}auth/admin/updateEmployee/${id}`, body, {
      headers,
    })
    .then((result) => result);

  return data;
};
